import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';

import { activeShop, getActiveBrandShops } from '../../../../auth/selectors';
import { withActionByRole } from '../../../../common/helpers/actions';
import withNotifications from '../../../../common/withNotifications';
import * as actions from '../../actions';

const AddProductContainer = compose(
  connect((state) => ({
    shops: getActiveBrandShops(state) || (activeShop(state) ? [activeShop(state)] : []),
  })),
  withProps({
    isEditing: false,
    header: 'products:products.add_button',
  }),
  withNotifications,
  withActionByRole('addProduct', actions.addShopItem, actions.addBarberItem, actions.addBrandItem),
  withHandlers({
    save: (props) => async (values) => {
      await props.addProduct(values);
      props.addNotification({
        title: t('common:done'),
        level: 'success',
        message: t('products:products.add_success_message'),
      });
    },
    resetOverridesForShops: () => () => {
      // do nothing for add
    },
  }),
  withProps((props) => {
    const product = {
      assignments: (props.shops || []).map((shop) => ({
        enabled: true,
        inventory: 0,
        ownerId: shop.id,
        name: shop.alias || shop.name,
      })),
    };

    const assignments = (props.shops || []).reduce(
      (acc, shop) => ({
        ...acc,
        [shop.id]: {
          enabled: true,
          inventory: 0,
          ownerId: shop.id,
          name: shop.alias || shop.name,
        },
      }),
      {}
    );

    return {
      product,
      initialValues: {
        isRetail: true,
        assignments,
        allEnabled: true,
      },
    };
  })
);

export default AddProductContainer;
